export default "__VITE_ASSET__CrPiEsH1__"